import script from "./Advantages.vue?vue&type=script&setup=true&lang=js"
export * from "./Advantages.vue?vue&type=script&setup=true&lang=js"

import "./Advantages.vue?vue&type=style&index=0&id=552aa1be&lang=scss"

const __exports__ = script;

export default __exports__